export function getScoreTableColumnsColumns(handlers) {
  return getColumns(handlers, scoreTableColumns);
}

export function getReviewStatusColumns(handlers) {
  return getColumns(handlers, reviewStatusColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const reviewStatusColumns = [
  {
    text: "상태",
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: "차수",
    value: "level",
    type: "text",
  },
  {
    text: "제목",
    value: "title",
    type: "text",
  },
  {
    text: "심사 시작일",
    value: "assigned_date",
    type: "text",
  },
  {
    text: "심사 마감일",
    value: "review_deadline",
    type: "text",
  },
  {
    text: "Actions",
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "description",
        color: "black",
        key: "description",
        handler: null,
      },
    ],
  },
];


const scoreTableColumns = [
  {
    text: "항목",
    value: "title",
    type: "text",
  },
  {
    text: "배점 입력",
    value: "score",
    type: "input",
  },
];
